import React from "react";

import ReportChart from "./ReportChart";
import { formatValue, isMeasure } from "../helpers";

/**
 * O resultado de um relatório: gráfico (quando o formato permite) e tabela com
 * a linha de totais. Usado pela tela do relatório e pela prévia do construtor —
 * as duas desenham exatamente o mesmo retorno do backend.
 */
export const ReportResult = ({ result, chartType, loading, emptyMessage }) => {
    if (loading) {
        return <div className="report-result-message">Calculando…</div>;
    }

    if (!result || result.columns.length === 0) {
        return <div className="report-result-message">{emptyMessage ?? 'Escolha ao menos uma coluna para ver o resultado.'}</div>;
    }

    if (result.rows.length === 0) {
        return <div className="report-result-message">Nenhum resultado no período escolhido.</div>;
    }

    const hasTotals = Object.keys(result.totals ?? {}).length > 0;

    return (
        <>
            <ReportChart result={result} type={chartType} />

            <div className="table-responsive">
                <table className="table report-table">
                    <thead>
                        <tr>
                            {result.columns.map(column => (
                                <th key={column.key} className={isMeasure(column) ? 'numeric' : ''}>{column.label}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {result.rows.map((row, index) => (
                            <tr key={index}>
                                {result.columns.map(column => (
                                    <td key={column.key} className={isMeasure(column) ? 'numeric' : ''}>
                                        {formatValue(row[column.key], column.type)}
                                    </td>
                                ))}
                            </tr>
                        ))}
                        {hasTotals &&
                            <tr className="report-total-row">
                                {result.columns.map((column, index) => (
                                    <td key={column.key} className={isMeasure(column) ? 'numeric' : ''}>
                                        {column.key in result.totals
                                            ? formatValue(result.totals[column.key], column.type)
                                            : (index === 0 ? 'Total' : '')}
                                    </td>
                                ))}
                            </tr>
                        }
                    </tbody>
                </table>
            </div>

            {result.truncated &&
                <div className="report-truncated">
                    Resultado cortado em {new Intl.NumberFormat('pt-BR').format(result.row_limit)} linhas. Estreite o período ou agrupe o relatório — a exportação leva bem mais linhas que a tela.
                </div>
            }
        </>
    );
};

export default ReportResult;
